import { SweepDestinationType } from '@/services/apis/sweep/models'
import { Tag } from 'antd'
import { memo, FC } from 'react'
import { useTranslation } from '@/services/i18n'
import { getWalletTagName } from '@/utils/utils'
import { WalletType } from '@/services/apis/wallet/models'

interface Props {
  type?: SweepDestinationType | WalletType
}

const AccountTypeTag: FC<Props> = ({ type }) => {
  const { t } = useTranslation()
  if (!type) {
    return null
  }

  if (typeof type === 'number' && type === WalletType.asset) {
    type = 'VAULT_ACCOUNT'
  }
  return <Tag>{`${getWalletTagName(type as SweepDestinationType, t)}`}</Tag>
}

export default memo(AccountTypeTag)
